import { Alert, useTheme } from "@mui/material";

const MaintenanceAlert = () => {
    const theme = useTheme();
    return (
        <Alert
            severity="error"
            sx={{
                height: "72px",
                borderRadius: "0px",
                [theme.breakpoints.up("md")]: {
                    paddingLeft: "132px"
                }
            }}
        >
            SCHEDULED MAINTENANCE - THURSDAY, SEPTEMBER 26, 2024, 9:00PM - 12:00AM (EDT)<br /> Our system will be temporarily
            unavailable on Thursday, September 26, while we perform planned
            system maintenance.
        </Alert>
    );
};

export default MaintenanceAlert;
